export default "__VITE_ASSET__BrK6eJox__"